import { render, staticRenderFns } from "./realtimeData.vue?vue&type=template&id=1e8bd144&scoped=true&"
import script from "./realtimeData.vue?vue&type=script&lang=js&"
export * from "./realtimeData.vue?vue&type=script&lang=js&"
import style0 from "./realtimeData.vue?vue&type=style&index=0&id=1e8bd144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8bd144",
  null
  
)

component.options.__file = "realtimeData.vue"
export default component.exports